import { render, staticRenderFns } from "./doDiningList.vue?vue&type=template&id=be5b84d6&scoped=true"
import script from "./doDiningList.vue?vue&type=script&lang=js"
export * from "./doDiningList.vue?vue&type=script&lang=js"
import style0 from "./doDiningList.vue?vue&type=style&index=0&id=be5b84d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5b84d6",
  null
  
)

export default component.exports